function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h20l10 9.75V40H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFCE00",
  fillRule: "nonzero",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#08003C",
  mask: "url(#b)",
  d: "M6.463 14h2.354l5.102 4.476-5.102 11.99H6.463l2.354-11.033z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#08003C",
  mask: "url(#b)",
  d: "M11 14h2.354l5.092 3.618-5.092 12.849H11l2.59-11.879z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#08003C",
  mask: "url(#b)",
  d: "M16 14h2.354l4.773 2.588-4.773 13.879H16l2.127-12.879z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE05D",
  fillRule: "nonzero",
  mask: "url(#b)",
  d: "M20 0h10v10H20z"
}));

var SvgMiro = function SvgMiro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMiro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/miro.9dea54d6.svg";
export { ForwardRef as ReactComponent };